import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import translate from '@i18n'
import IconButton from '@components/Buttons/IconButton'

type SearchbarContainerProps = {
  children: ReactNode
  onClose: () => void
  onBack?: () => void
}

const OuterWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
      colors: { strokeDefaultDisabled },
    },
  }) => css`
    display: flex;
    border-bottom: 1px solid ${strokeDefaultDisabled};
    padding: ${spacing16} 0;
  `}
`

const DrawerCloseIconButton = styled(IconButton)`
  ${({
    theme: {
      colors: { iconDefault },
    },
  }) => css`
    ${mobileAndTabletCSS(css`
      display: none;
    `)}
    color: ${iconDefault};
    margin-left: auto;
  `}
`

const BackIconButton = styled(IconButton)`
  ${({
    theme: {
      colors: { iconDefault },
    },
  }) => css`
    ${desktopCSS(css`
      display: none;
    `)}
    margin-right: auto;
    color: ${iconDefault};
  `}
`

const SearchbarContainer: FunctionComponent<SearchbarContainerProps> = ({
  children,
  onClose,
  onBack,
}) => {
  return (
    <OuterWrapper>
      <BackIconButton
        ariaLabel={translate('back')}
        buttonSize={48}
        onClick={onBack ?? onClose}
        iconName="chevron-left"
        iconSize={24}
      />
      {children}
      <DrawerCloseIconButton
        ariaLabel={translate('close')}
        buttonSize={48}
        onClick={onClose}
        iconName="xmark-large"
        iconSize={24}
      />
    </OuterWrapper>
  )
}

export default SearchbarContainer
